import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.main.bg};
  display: flex;
  justify-content: center;
  align-items: center;
`

const Slides = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1.2s ease;

  &.current-slide {
    opacity: 1;
  }
`

const Slide = styled.img`
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export default function HomeTopSlideshow({ slides, start }) {
  const [current, setCurrent] = useState(0)
  const started = useRef(false)
  const _isMounted = useRef(false)

  useEffect(() => {
    _isMounted.current = true

    return () => {
      _isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (start && !started.current) {
      animate()
      started.current = true
    }
  }, [start, started.current])

  useEffect(() => {
    if (started.current) {
      animate()
    }
  }, [current])

  function animate() {
    setTimeout(() => {
      if (!_isMounted.current) return

      setCurrent(prev => (prev < slides.length - 1 ? prev + 1 : 0))
    }, 4000)
  }

  return (
    <Wrapper>
      {slides.map(
        (slide, i) =>
          console.log(slide) || (
            <Slides key={slide.src} className={current === i ? 'current-slide' : ''}>
              <picture>
                <source media="(min-width: 601px)" srcSet={slide.src} />
                <source media="(orientation: portrait)" srcSet={slide.srcMobile} />
                <Slide alt={slide.alt} src={slide.src} />
              </picture>
            </Slides>
          )
      )}
    </Wrapper>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomeTopSlideshow.js